import React from 'react';
import PayverseMobProcess from 'app/components/OrderPayment/Payverse/PayverseMobProcess';

const PayversePaymentMob = () => {
  return <PayverseMobProcess />;
};

export default PayversePaymentMob;
